import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import UserLayout from '../components/UserLayout';
import Card, { CardBody } from '../components/Card';
import { SearchIcon } from 'lucide-react';
import { mdas } from '../data/mdas';
const MDAsPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredMDAs = mdas.filter(mda => mda.name.toLowerCase().includes(searchTerm.toLowerCase()) || mda.acronym.toLowerCase().includes(searchTerm.toLowerCase()) || mda.description.toLowerCase().includes(searchTerm.toLowerCase()));
  return <UserLayout data-id="element-5530">
      <div className="py-8 px-4 sm:px-6 lg:px-8" data-id="element-5531">
        <div className="max-w-7xl mx-auto" data-id="element-5532">
          {/* Page Header */}
          <div className="mb-8" data-id="element-5533">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-5534">
              Ministries, Departments & Agencies
            </h1>
            <p className="text-gray-600 mt-1" data-id="element-5535">
              Browse and access services from all Edo State government
              institutions
            </p>
          </div>
          {/* Search Bar */}
          <div className="mb-8" data-id="element-5536">
            <div className="max-w-lg" data-id="element-5537">
              <div className="relative" data-id="element-5538">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-5539">
                  <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-5540" />
                </div>
                <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm" placeholder="Search for an MDA by name or acronym" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-5541" />
              </div>
            </div>
          </div>
          {/* MDAs Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5542">
            {filteredMDAs.map(mda => <Link key={mda.id} to={`/mdas/${mda.id}/services`} data-id="element-5543">
                <Card className="h-full hover:shadow-md transition-shadow" data-id="element-5544">
                  <CardBody className="p-6" data-id="element-5545">
                    <div className="flex items-center mb-4" data-id="element-5546">
                      <img src={mda.logoUrl} alt={`${mda.name} Logo`} className="h-12 w-12 mr-4" data-id="element-5547" />
                      <div data-id="element-5548">
                        <h2 className="text-xl font-semibold text-gray-900" data-id="element-5549">
                          {mda.acronym}
                        </h2>
                        <p className="text-sm text-gray-500" data-id="element-5550">
                          {mda.serviceCount} services available
                        </p>
                      </div>
                    </div>
                    <h3 className="font-medium text-gray-900 mb-2" data-id="element-5551">
                      {mda.name}
                    </h3>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-5552">
                      {mda.description}
                    </p>
                    <div className="mt-auto pt-4 flex justify-end" data-id="element-5553">
                      <span className="text-green-600 text-sm font-medium" data-id="element-5554">
                        Browse Services &rarr;
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Link>)}
          </div>
          {filteredMDAs.length === 0 && <div className="text-center py-12" data-id="element-5555">
              <p className="text-gray-500" data-id="element-5556">
                No MDAs found matching your search criteria.
              </p>
            </div>}
        </div>
      </div>
    </UserLayout>;
};
export default MDAsPage;